<template>
  <header class="header">
    <div class="inner">
      <div class="logo-wrapper">
        <div class="logo"></div>
        <div class="line"></div>
        <h2 class="title">创作者服务平台</h2>
      </div>
      <div class="info-wrapper">
        <el-popover placement="bottom" width="160" v-model="visible">
          <p>您确定要退出吗？</p>
          <div class="avatar-wrapper">
            <el-button size="mini" type="text" @click="visible = false">
              取消
            </el-button>
            <el-button type="primary" size="mini" @click="handleSubmitLogout">
              确定</el-button
            >
          </div>
          <img :src="userInfo.avatar" alt="" class="avatar" slot="reference" />
        </el-popover>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { clearLoginInfoFromCookie } from '../../utils/index';

export default {
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  methods: {
    ...mapMutations(['CLEAR_ALL_INFO', 'RESET_ROUTER']),
    handleSubmitLogout() {
      clearLoginInfoFromCookie();
      this.CLEAR_ALL_INFO();
      this.RESET_ROUTER();
      this.$router.push({ path: '/login' });
    },
  },
};
</script>

<style lang="scss">
.avatar-wrapper {
  padding-top: 10px;
  text-align: right;
}
</style>

<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;

  width: 100%;
  background: #ffffff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1000;

  .inner {
    display: flex;
    height: 64px;
    justify-content: space-between;
    align-items: center;
    width: 1280px;
    margin: 0 auto;
  }

  .logo-wrapper {
    display: flex;
    align-items: center;

    .logo {
      width: 114px;
      height: 38px;
      background: url(~@/assets/images/icon_logo.png) no-repeat;
    }
    .line {
      width: 1px;
      height: 20px;
      margin: 0 23px;
      background: #d9d9d9;
    }
    .title {
      font-size: 16px;
      line-height: 24px;
      color: #497db1;
    }
  }

  .info-wrapper {
    .avatar {
      display: block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      overflow: hidden;
      cursor: pointer;
    }
  }
}
</style>
